<template>
  <div class="app-rate" dir="ltr">
    <ElRate :value="rate" disabled text-color="#ff9900" />

    <div class="app-rate__summary">
      <span class="app-rate__spacer" />
      <i class="material-icons">person</i>
      <span>{{ numberFormat(count) }}</span>
    </div>
  </div>
</template>

<script>
import { format as numberFormat } from '@/utils/number';

export default {
  name: 'AppRate',

  props: {
    count: {
      type: Number,
      default: 0,
    },
    rate: {
      type: Number,
      default: 0,
    },
  },

  methods: { numberFormat },
};
</script>

<style lang="scss">
.app-rate {
  display: flex;

  &__summary {
    font-size: $small-font-size;

    i {
      color: $lb-darker-gray;
      font-size: $global-font-size;
    }

    span {
      vertical-align: -1px;
    }
  }

  &__spacer {
    border-right: 1px solid $lb-light-gray;
    margin: 0 $global-margin / 2;
  }
}
</style>
